import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import CategoryForm from "./CategoryForm";

const AddNewCategory = () => {
  const [form] = Form.useForm();
  const curdProps = useSelector((state) => state.CurdR);
  const { Add_Category_Modal, Loader } = curdProps;

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Category"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addHealthCategory"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_Category_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_Category_Modal ? Add_Category_Modal : false}
      width={500}
      recordName="categoryList"
      form={form}
    >
      <CategoryForm />
    </FormModal>
  );
};

export default AddNewCategory;
